import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from "../../shared";
import { MTOComponentLabelLinkContainerModel } from '../../../../../../models/aggregates/erp/mto/mto-component-label-link-container.model';

@Injectable({
  providedIn: 'root'
})
export class MTOComponentLabelLinkService extends BaseApiTemplateService<MTOComponentLabelLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'component-label-links/backoffice-ep';
  readonly endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'component-label-links/' + Core2Config.PUBLIC_EP_SUFFIX;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'component-label-links/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'component-label-links/backoffice-ep';
    this.httpClient = http;
  }

  getByCriteriaPublic(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path_public_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_public_url;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<MTOComponentLabelLinkContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}

